import  { createContext, useState, useEffect, useContext } from 'react';
import axios from "@fetch/axios";
import { TokenContext } from '@context/TokenContext';
import { LanguageCurrencyContext } from '@context/LanguageCurrencyContext';

export const CartContext = createContext({
  cartItems: [],
  totalQuantity: 0,
  totalPay: 0,
  shipping: 0,
  subtotalPay:0,
  cartId: null,
  addToCartVerified: () => { },
  addToCartGuest:()=> {},
  removeToCart: () => { },
  addPrevent: () => { },
  removePrevent: () => { },
  getCartItems: () => { },
  getCardId: () => { },
  getDescuento: () => { },
  resetCart: () => { },
  getShipping: () => { },
  loadCartFromLocalStorage: () => { },
  saveCartToLocalStorage : () => { }

});

export const CartProvider = ({ children }) => {

  const [cartItems, setCartItems] = useState([]);
  const [cartId, setCartId] = useState(null);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalPay, setTotalPay] = useState(0);
  const [subtotalPay, setSubtotalPay] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [shipping, setShipping] = useState(0);
  const { getToken,getVerified } = useContext(TokenContext);
  const { lang, currency } = useContext(LanguageCurrencyContext);

  // Función para actualizar el estado del carrito desde localStorage
  const loadCartFromLocalStorage = async () => {

    //llamamos api para consultar carrito actual de cliente
    if (getToken() && getVerified()) {

      try {

        const res = await axios.get('/cart/active' + `?lang=` + lang + `&currency=` + currency, {
          headers: { 'Authorization': 'Bearer ' + getToken() }
        });

        let cart = res.data

        if (cart.id) {

          localStorage.setItem('cartId', cart.id);

          setCartId(cart.id)               //obtiene el id del carrito activod
          setCartItems(cart.products)      //obtiene los productos del carrito
          setTotalQuantity(cart.articles)  //obtiene el total de articulos en el carrito
          saveCartToLocalStorage(cart.products)         //guardamos en el storage los productos

        } else {

          setCartId(null)
          setCartItems([]);
          setTotalQuantity(0);
          localStorage.setItem('cart', '[]');
          localStorage.setItem('cartId', '');

        }

      } catch (error) {

        console.log(error)
        localStorage.removeItem('cart');
        localStorage.removeItem('cartId');
        clearTokenIfUnverified();
        localStorage.removeItem('user_arteonu');
        localStorage.removeItem('addPrevent');
        localStorage.removeItem('token_recuperar_clave');
        localStorage.removeItem('roken_volver_crear');

      }

    }else{

      let storedCart = JSON.parse(localStorage.getItem('cart') ?? '[]');
      setTotalQuantity(storedCart.length);
      setCartItems(storedCart.length);

    }

  };

  const addToCartVerified = async (item) => {

    if (cartId) {

            let array = Array.isArray(cartItems) ? [...cartItems] : [];
      let sub = [];

      // Función auxiliar para manejar la conversión a NULL si no hay valor
      const getNumericId = (value) => {
          const num = parseInt(value);
          return isNaN(num) ? null : num;
      };

      // 1. Preparamos el item entrante usando la función auxiliar
      const item_size = getNumericId(item.size_id);
      const item_color = getNumericId(item.color_id); // USAMOS LA FUNCIÓN AQUÍ
      const item_id = item.id; // Asumimos que ID no necesita conversión

      // 2. Construimos 'sub' con copias de los elementos existentes, usando la función auxiliar
      array.forEach(element => {
          const el = { ...element };
          el.size_id = getNumericId(el.size_id);
          el.color_id = getNumericId(el.color_id); // USAMOS LA FUNCIÓN AQUÍ
          el.quantity = parseInt(el.quantity || 0);
          sub.push(el);
      });

      // 3. Buscar si incoming item coincide con alguno (La lógica de búsqueda ahora funciona)
      const encontrado = sub.find(element => {
          // Los elementos en 'sub' (element) ya están convertidos a 'null' o número
          const elem_size = element.size_id;
          const elem_color = element.color_id;
          const elem_id = element.id;

          // item_size, item_color, y item_id tienen el mismo tipo de valor ('null' o número)
          return item_size === elem_size && 
                item_id === elem_id && 
                item_color === elem_color; // Ahora esta comparación será correcta
      });

      if (!encontrado) {
          // Agregar el ítem (utilizando los valores ya convertidos)
          const newItem = { ...item };
          newItem.size_id = item_size;
          newItem.color_id = item_color;
          newItem.quantity = parseInt(item.quantity || 0) || 1;
          sub.push(newItem);
      } else {
          // Actualizar la cantidad
          const addQty = parseInt(item.quantity || 0) || 0;
          encontrado.quantity = (addQty);
      }

      const id_cart = localStorage.getItem('cartId') ?? cartId;

      const res = await axios.put(`/cart/update?currency=${currency}&lang=${lang}`, {
        id: id_cart,
        products: sub
      }, {
        headers: { 'Authorization': 'Bearer ' + getToken() }
      });

      setTotalPay(res.data.total)
      setDescuento(res.data.discount)
      setShipping(res.data.shipping)
      setSubtotalPay(res.data.subtotal)
      setCartItems(res.data.products);
      setTotalQuantity(res.data.articles);
      saveCartToLocalStorage(res.data.products);

    } else {
      // creamos el carrito
      item.size_id = parseInt(item.size_id);
      item.color_id = parseInt(item.color_id);
      
      const res = await axios.post(`/cart/create?currency=${currency}&lang=${lang}`, {
        products: [item]
      }, {
        headers: { 'Authorization': 'Bearer ' + getToken() }
      });

      localStorage.setItem('cartId', res.data.id);
      setTotalPay(res.data.total)
      setDescuento(res.data.discount)
      setShipping(res.data.shipping)
      setSubtotalPay(res.data.subtotal)
      setTotalQuantity(res.data.articles);
      setCartId(res.data.id)
      setCartItems([item]);
      saveCartToLocalStorage([item]);

    }
  };

  const addToCartGuest = async (item) => {
  
    const price = item.price_offer ? getValue(item.price_offer) : getValue(item.price);

    if (cartId) {
      let array = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : [];
      let sub = [];

      // Función auxiliar para manejar la conversión a NULL si no hay valor
      const getNumericId = (value) => {
          const num = parseInt(value);
          return isNaN(num) ? null : num;
      };

      // 1. Preparamos el item entrante usando la función auxiliar
      const item_size = getNumericId(item.size_id);
      const item_color = getNumericId(item.color_id); // USAMOS LA FUNCIÓN AQUÍ
      const item_id = item.id; // Asumimos que ID no necesita conversión

      // 2. Construimos 'sub' con copias de los elementos existentes, usando la función auxiliar
      array.forEach(element => {
          const el = { ...element };
          el.size_id = getNumericId(el.size_id);
          el.color_id = getNumericId(el.color_id); // USAMOS LA FUNCIÓN AQUÍ
          el.quantity = parseInt(el.quantity || 0);
          sub.push(el);
      });

      // 3. Buscar si incoming item coincide con alguno (La lógica de búsqueda ahora funciona)
      const encontrado = sub.find(element => {
          // Los elementos en 'sub' (element) ya están convertidos a 'null' o número
          const elem_size = element.size_id;
          const elem_color = element.color_id;
          const elem_id = element.id;

          // item_size, item_color, y item_id tienen el mismo tipo de valor ('null' o número)
          return item_size === elem_size && 
                item_id === elem_id && 
                item_color === elem_color; // Ahora esta comparación será correcta
      });

      if (!encontrado) {
          // Agregar el ítem (utilizando los valores ya convertidos)
          const newItem = { ...item };
          newItem.size_id = item_size;
          newItem.color_id = item_color;
          newItem.quantity = parseInt(item.quantity || 0) || 1;
          sub.push(newItem);
      } else {
          // Actualizar la cantidad
          const addQty = parseInt(item.quantity || 0) || 0;
          encontrado.quantity = (addQty);
      }
  

      let total = 0;
      sub.forEach(element => {
        total += ((element.price_offer ? getValue(element.price_offer) : getValue(element.price)) * element.quantity);
      })

      total = valueFormat(total);
      setTotalPay(total)
      setSubtotalPay(total)
      setCartItems(sub);
      setTotalQuantity(sub.length);
      saveCartToLocalStorage(sub);

    } else {
      // creamos el carrito
      item.size_id = parseInt(item.size_id);
      item.color_id = parseInt(item.color_id);
      const total = valueFormat(price*item.quantity)
      localStorage.setItem('cartId', 'guest');
      setTotalPay(total)
      setDescuento(0)
      setShipping(0)
      setSubtotalPay(total)
      setTotalQuantity(1);
      setCartId('guest')
      setCartItems([item]);
      saveCartToLocalStorage([item]);

    }
  };

  function getValue(valor) {
    if (valor == null) return NaN;
    if (typeof valor === 'number' && !isNaN(valor)) return valor;

    const str = String(valor).trim();

    // Buscar el primer token numérico (soporta formatos como 1.234,56 ó 1,234.56)
    const matches = str.match(/-?\d{1,3}(?:[.,]\d{3})*(?:[.,]\d+)?/g);
    if (!matches) return NaN;

    let token = matches[0];

    const hasDot = token.indexOf('.') !== -1;
    const hasComma = token.indexOf(',') !== -1;

    let normalized = token;

    if (hasDot && hasComma) {
      // Ambos presentes: decidir cuál es decimal según el último separador
      const lastDot = token.lastIndexOf('.');
      const lastComma = token.lastIndexOf(',');
      if (lastDot > lastComma) {
        // '.' es decimal, quitar comas (miles)
        normalized = token.replace(/,/g, '');
      } else {
        // ',' es decimal, quitar puntos (miles) y convertir ',' -> '.'
        normalized = token.replace(/\./g, '').replace(/,/g, '.');
      }
    } else if (hasComma && !hasDot) {
      // Solo coma -> asumir coma decimal
      normalized = token.replace(/,/g, '.');
    } else if (hasDot && !hasComma) {
      // Solo punto -> si hay varios puntos, tratar último como decimal y unir los demás
      const dotCount = (token.match(/\./g) || []).length;
      if (dotCount > 1) {
        const parts = token.split('.');
        const dec = parts.pop();
        normalized = parts.join('') + '.' + dec;
      }
    }

    // Quitar cualquier carácter extraño restante (dejamos dígitos, '-', y '.')
    normalized = normalized.replace(/[^\d.-]/g, '');

    const num = Number(normalized);
    return isNaN(num) ? NaN : num;
  }

  function valueFormat(valor){
    const n = Number(valor || 0);
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
  }

  const removeToCart = async (item) => {

    let array = cartItems
    let sub = [];

    let item_size = parseInt(item.size_id);
    let item_color = item.color_id ? parseInt(item.color_id) : null;
    let item_id = item.id;

    array.forEach(element => {
      let elem_size = parseInt(element.size_id);
      let elem_color = element.color_id ? parseInt(element.color_id) : null;
      let elem_id = element.id;
  
      if (item_size === elem_size && item_id === elem_id && item_color === elem_color) {
        // No agregar este elemento (lo eliminamos)
      } else {
        element.size_id = parseInt(element.size_id);
        element.color_id = element.color_id ? parseInt(element.color_id) : null;
        sub.push(element)
      }
    });

    const id_cart = localStorage.getItem('cartId') ?? cartId;
    if(id_cart=='guest'){

      let total = 0;
      sub.forEach(element => {
        total += ((element.price_offer ? getValue(element.price_offer) : getValue(element.price)) * element.quantity);
      })

      total = valueFormat(total);
      setTotalPay(total)
      setSubtotalPay(total)
      setDescuento(0)
      setShipping(0)
      setCartItems(sub);
      saveCartToLocalStorage(sub);
      setTotalQuantity(sub.length);

    }else{

      const res = await axios.put(`/cart/update?currency=${currency}`, {
        id: id_cart,
        products: sub
      }, {
        headers: { 'Authorization': 'Bearer ' + getToken() }
      });
  
      setTotalPay(res.data.total)
      setSubtotalPay(res.data.subtotal)
      setDescuento(res.data.discount)
      setShipping(res.data.shipping)
      setCartItems(sub);
      saveCartToLocalStorage(sub);
      setTotalQuantity(res.data.articles);
    }

    return true;
  };

  const addPrevent = (item) => {
    localStorage.setItem('addPrevent', JSON.stringify(item))
  }

  const removePrevent = () => {
    localStorage.removeItem('addPrevent')
    localStorage.removeItem('add_cart_arteonu')
  }

  function clearTokenIfUnverified() {
    const storedUser = localStorage.getItem('user_arteonu');
    if (!storedUser) return;

    try {
      const parsedUser = JSON.parse(storedUser);
      if (parsedUser?.verified === 0) {
        localStorage.removeItem('token_arteonu');
      }
    } catch (err) {
      // ignore malformed user data
    }
  }

  const saveCartToLocalStorage = (items = null) => {
    localStorage.setItem('cart', JSON.stringify(items ? items : cartItems));
  };

  const getCartItems = () => {
    return cartItems;
  }

  const getDescuento = () => {
    return descuento;
  }

  const getShipping = () => {
    return shipping;
  }

  const getCardId = () => {
    return localStorage.getItem('cartId');
  }

  const resetCart = () => {
    setCartId(null)
    setCartItems([]);
    setTotalQuantity(0);
    localStorage.setItem('cart', '[]');
    localStorage.removeItem('cartId');
    localStorage.removeItem('addPrevent');
    clearTokenIfUnverified();

  }

  useEffect(() => {
    loadCartFromLocalStorage();
  }, [lang, currency]);

  return (
    <CartContext.Provider value={{
      cartItems,
      totalQuantity,
      totalPay,
      shipping,
      subtotalPay,
      descuento,
      cartId,
      setTotalPay,
      setSubtotalPay,
      setTotalQuantity,
      setDescuento,
      setShipping,
      addToCartVerified,
      addToCartGuest,
      removeToCart,
      addPrevent,
      removePrevent,
      getCartItems,
      getCardId,
      getDescuento,
      resetCart,
      getShipping,
      loadCartFromLocalStorage,
      saveCartToLocalStorage 
    }}>
      {children}
    </CartContext.Provider>
  );
};
